// Keep these dates in sync with meaningful, user-visible updates to the page.
// Do not change them for deploys, shared layout changes, or other incidental edits.
const PAGE_LAST_MODIFIED = {
  "/avtomobilni-zastrahovki/": "2026-06-18",
  "/best-doctors/": "2026-07-04",
  "/detska-zastrahovka/": "2026-03-27",
  "/dopulnitelno-zdravno-bulstrad/": "2026-05-12",
  "/firmena-zastrahovka-zhivot/": "2026-04-21",
  "/firmeni-zastrahovki/": "2026-07-16",
  "/grazhdanska-otgovornost-online/": "2026-08-31",
  "/kasko-kalkulator/": "2026-08-31",
  "/kasko-plus-grazhdanska/": "2026-05-29",
  "/planinska-zastrahovka/": "2026-02-14",
  "/statistics-go/": "2026-09-08",
  "/statistics-kasko/": "2026-09-08",
  "/statistics-travel/": "2026-09-08",
  "/zastrahovka-bolnichen-prestoi/": "2026-03-08",
  "/zastrahovka-ekstremni-sportove/": "2026-01-23",
  "/zastrahovka-imushtestvo/": "2026-07-11",
  "/zastrahovka-jivot/": "2026-04-08",
  "/zastrahovka-patuvane-v-chuzhbina/": "2026-08-31",
  "/zastrahovka-zhivot-investitsionen-fond/": "2026-05-04",
  "/zastrahovki-zhivot/": "2026-02-26",
  "/zdravna-zastrahovka-for-foreigners/": "2026-09-08",
  "/zdravna-zastrahovka-health-club/": "2026-05-19",
  "/zdravni-zastrahovki/": "2026-06-30",
  "/asigurare-de-calatorie/": "2026-04-30"
};

const PRODUCT_PAGE_PATHS = {
  AutoInsurances: "/avtomobilni-zastrahovki/",
  HWP: "/best-doctors/",
  ChieldInsurances: "/detska-zastrahovka/",
  HCEF: "/dopulnitelno-zdravno-bulstrad/",
  CI: "/firmena-zastrahovka-zhivot/",
  CompanyInsurances: "/firmeni-zastrahovki/",
  GO: "/grazhdanska-otgovornost-online/",
  CSC: "/kasko-kalkulator/",
  "CSC+GO": "/kasko-plus-grazhdanska/",
  MTN: "/planinska-zastrahovka/",
  HLT: "/zastrahovka-bolnichen-prestoi/",
  EXT: "/zastrahovka-ekstremni-sportove/",
  PRP: "/zastrahovka-imushtestvo/",
  LFE: "/zastrahovka-jivot/",
  TRA: "/zastrahovka-patuvane-v-chuzhbina/",
  LFI: "/zastrahovka-zhivot-investitsionen-fond/",
  LifeInsurances: "/zastrahovki-zhivot/",
  FHLT: "/zdravna-zastrahovka-for-foreigners/",
  HCL: "/zdravna-zastrahovka-health-club/",
  HealthInsurances: "/zdravni-zastrahovki/"
};

const normalizePagePath = path => {
  const withoutLanguage = (path || "/").replace(/^\/[a-z]{2}(?=\/|$)/, "") || "/";
  return withoutLanguage.endsWith("/") ? withoutLanguage : `${withoutLanguage}/`;
};

const getPageLastModified = path => PAGE_LAST_MODIFIED[normalizePagePath(path)];

const getProductPageLastModified = product => getPageLastModified(PRODUCT_PAGE_PATHS[product]);

module.exports = {
  PAGE_LAST_MODIFIED,
  PRODUCT_PAGE_PATHS,
  getPageLastModified,
  getProductPageLastModified
};
